var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-list',{attrs:{"endpoint":"grupo-conteudo","rota-base":"/admin/grupo-conteudo","titulo":"GRUPOS DE CONTEÚDO","titulo-singular":"Grupo de Conteúdo","colunas-extras":[{"campo":"descricao","label":"Descrição","tipo":"text","span":24}]}})
}
var staticRenderFns = []

export { render, staticRenderFns }